<div class="excel-column">
    <button mat-raised-button color="accent" (click)="clearExcelColumnList()" class="clear">Limpiar</button>
    <div class="columns-list">        
        

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
       <caption></caption>
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="columnName">
                <th mat-header-cell *matHeaderCellDef> Fields  </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <mat-form-field appearance="fill">
                        <mat-select  [(value)]="element.columnName">
                             <mat-option *ngFor="let item of camposImportacionList" [value]="item">
                                {{item}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-button>
                        <mat-icon (click)="clearColumn(element)">clear</mat-icon>
                    </button>
               </td>
            </ng-container>

            <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


    </div>
</div>